import { Observable } from 'rxjs';
import type { SupportedTokens } from '@coin-depo-types';

export interface TokenFacade {
  cachedSupportedTokens$: Observable<SupportedTokens[]>;
  allCachedSupportedTokens$: Observable<SupportedTokens[]>;

  getSupportedTokensByIdSnapshot(
    id: string | number
  ): SupportedTokens | undefined;

  getSupportedTokensSnapshot(): SupportedTokens[];

  getSupportedTokensByNameSnapshot(
    name: string
  ): SupportedTokens | undefined;

  updateSupportedTokens(): Observable<unknown>;
}